"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClient = exports.matchPath = exports.getLargeMediaPatternsFromGitAttributesFile = exports.createPointerFile = exports.parsePointerFile = void 0;

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _fromPairs2 = _interopRequireDefault(require("lodash/fp/fromPairs"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _filter2 = _interopRequireDefault(require("lodash/fp/filter"));

var _minimatch = _interopRequireDefault(require("minimatch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//
// Pointer file parsing
const splitIntoLines = str => str.split('\n');

const splitIntoWords = str => str.split(/\s+/g);

const isNonEmptyString = str => str !== '';

const withoutEmptyLines = (0, _flow2.default)([(0, _map2.default)(str => str.trim()), (0, _filter2.default)(isNonEmptyString)]);
const parsePointerFile = (0, _flow2.default)([splitIntoLines, withoutEmptyLines, (0, _map2.default)(splitIntoWords), _fromPairs2.default, (_ref) => {
  let {
    size,
    oid
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["size", "oid"]);

  return _objectSpread({
    size: parseInt(size),
    sha: oid.split(':')[1]
  }, rest);
}]);
exports.parsePointerFile = parsePointerFile;

const createPointerFile = (_ref2) => {
  let {
    size,
    sha
  } = _ref2;
  return "version https://git-lfs.github.com/spec/v1\noid sha256:".concat(sha, "\nsize ").concat(size, "\n");
}; //
// .gitattributes file parsing


exports.createPointerFile = createPointerFile;

const removeGitAttributesCommentsFromLine = line => line.split('#')[0];

const parseGitPatternAttribute = attributeString => {
  // There are three kinds of attribute settings:
  // - a key=val pair sets an attribute to a specific value
  // - a key without a value and a leading hyphen sets an attribute to false
  // - a key without a value and no leading hyphen sets an attribute
  //   to true
  if (attributeString.includes('=')) {
    return attributeString.split('=');
  }

  if (attributeString.startsWith('-')) {
    return [attributeString.slice(1), false];
  }

  return [attributeString, true];
};

const parseGitPatternAttributes = (0, _flow2.default)([(0, _map2.default)(parseGitPatternAttribute), _fromPairs2.default]);
const parseGitAttributesPatternLine = (0, _flow2.default)([splitIntoWords, (_ref3) => {
  let [pattern, ...attributes] = _ref3;
  return [pattern, parseGitPatternAttributes(attributes)];
}]);
const parseGitAttributesFileToPatternAttributePairs = (0, _flow2.default)([splitIntoLines, (0, _map2.default)(removeGitAttributesCommentsFromLine), withoutEmptyLines, (0, _map2.default)(parseGitAttributesPatternLine)]);
const getLargeMediaPatternsFromGitAttributesFile = (0, _flow2.default)([parseGitAttributesFileToPatternAttributePairs, (0, _filter2.default)( // eslint-disable-next-line no-unused-vars
(_ref4) => {
  let [pattern, attributes] = _ref4;
  return attributes.filter === 'lfs' && attributes.diff === 'lfs' && attributes.merge === 'lfs';
}), (0, _map2.default)((_ref5) => {
  let [pattern] = _ref5;
  return pattern;
})]);
exports.getLargeMediaPatternsFromGitAttributesFile = getLargeMediaPatternsFromGitAttributesFile;

const matchPath = (_ref6, path) => {
  let {
    patterns
  } = _ref6;
  return patterns.some(pattern => (0, _minimatch.default)(path, pattern, {
    matchBase: true
  }));
}; //
// API interactions


exports.matchPath = matchPath;
const defaultContentHeaders = {
  Accept: 'application/vnd.git-lfs+json',
  ['Content-Type']: 'application/vnd.git-lfs+json'
};

const resourceExists = async (_ref7, _ref8) => {
  let {
    rootURL,
    makeAuthorizedRequest
  } = _ref7;
  let {
    sha,
    size
  } = _ref8;
  const response = await makeAuthorizedRequest({
    url: "".concat(rootURL, "/verify"),
    method: 'POST',
    headers: defaultContentHeaders,
    body: JSON.stringify({
      oid: sha,
      size
    })
  });

  if (response.ok) {
    return true;
  }

  if (response.status === 404) {
    return false;
  } // TODO: what kind of error to throw here? APIError doesn't seem
  // to fit

};

const getDownloadURL = (_ref9, _ref10) => {
  let {
    rootURL,
    transformImages: t,
    makeAuthorizedRequest
  } = _ref9;
  let {
    sha
  } = _ref10;
  return makeAuthorizedRequest("".concat(rootURL, "/origin/").concat(sha).concat(t && Object.keys(t).length > 0 ? "?nf_resize=".concat(t.nf_resize, "&w=").concat(t.w, "&h=").concat(t.h) : '')).then(res => res.ok ? res : Promise.reject(res)).then(res => res.blob()).then(blob => URL.createObjectURL(blob)).catch(err => console.error(err) || Promise.resolve(''));
};

const getResourceDownloadURLArgs = (clientConfig, objects) => {
  return Promise.resolve(objects.map((_ref11) => {
    let {
      sha
    } = _ref11;
    return [sha, {
      sha
    }];
  }));
};

const getResourceDownloadURLs = (clientConfig, objects) => getResourceDownloadURLArgs(clientConfig, objects).then((0, _map2.default)(downloadURLArg => getDownloadURL(downloadURLArg))).then(Promise.all.bind(Promise));

const uploadOperation = objects => ({
  operation: 'upload',
  transfers: ['basic'],
  objects: objects.map((_ref12) => {
    let {
      sha
    } = _ref12,
        rest = _objectWithoutProperties(_ref12, ["sha"]);

    return _objectSpread({}, rest, {
      oid: sha
    });
  })
});

const getResourceUploadURLs = async (_ref13, objects) => {
  let {
    rootURL,
    makeAuthorizedRequest
  } = _ref13;
  const response = await makeAuthorizedRequest({
    url: "".concat(rootURL, "/objects/batch"),
    method: 'POST',
    headers: defaultContentHeaders,
    body: JSON.stringify(uploadOperation(objects))
  });
  return (await response.json()).objects.map(object => {
    if (object.error) {
      throw new Error(object.error.message);
    }

    return object.actions.upload.href;
  });
};

const uploadBlob = (clientConfig, uploadURL, blob) => fetch(uploadURL, {
  method: 'PUT',
  body: blob
});

const uploadResource = async (clientConfig, _ref14, resource) => {
  let {
    sha,
    size
  } = _ref14;
  const existingFile = await resourceExists(clientConfig, {
    sha,
    size
  });

  if (existingFile) {
    return sha;
  }

  const [uploadURL] = await getResourceUploadURLs(clientConfig, [{
    sha,
    size
  }]);
  await uploadBlob(clientConfig, uploadURL, resource);
  return sha;
}; //
// Create Large Media client


const configureFn = (config, fn) => function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return fn(config, ...args);
};

const clientFns = {
  resourceExists,
  getResourceUploadURLs,
  getResourceDownloadURLs,
  getResourceDownloadURLArgs,
  getDownloadURL,
  uploadResource,
  matchPath
};

const getClient = clientConfig => {
  return (0, _flow2.default)([Object.keys, (0, _map2.default)(key => [key, configureFn(clientConfig, clientFns[key])]), _fromPairs2.default, configuredFns => _objectSpread({}, configuredFns, {
    patterns: clientConfig.patterns,
    enabled: clientConfig.enabled
  })])(clientFns);
};

exports.getClient = getClient;